// 💾 src/pages/client/sections/PortfolioIndex.tsx
import { useState } from "react"
import Sidebar from "./components/Portfolio/Sidebar"
import BalanceHeader from "./components/Portfolio/BalanceHeader"
import EquityChart from "./components/Portfolio/EquityChart"
import TransactionsList from "./components/Portfolio/TransactionsList"
import MidPanel from "./components/Portfolio/MidPanel"
import BottomPanel from "./components/Portfolio/BottomPanel"

import SpotPanel from "./components/Portfolio/SpotPanel"
import FuturesPanel from "./components/Portfolio/FuturesPanel"
// TODO: Add others: DexPanel, FiatPanel, etc.

import "./style/Portfolio.scss"

const PortfolioIndex = () => {
  const [activeTab, setActiveTab] = useState("overview")

  return (
    <div className="portfolio-page">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />

      <main className="portfolio-main">
        <BalanceHeader />

        {activeTab === "overview" && <MidPanel />}
        {activeTab === "spot" && <SpotPanel />}
        {activeTab === "futures" && <FuturesPanel />}
        {/* TODO: Add more conditions for dex, fiat, bot, etc. */}

        <div className="portfolio-body">
          <EquityChart />
          <TransactionsList />
        </div>

        <BottomPanel />
      </main>
    </div>
  )
}

export default PortfolioIndex
